import { Component, Input, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { KENDO_FORM } from '@progress/kendo-angular-inputs';

@Component({
  selector: 'maximizer-outlook-form-error',
  template: `
    @if (errorObject !== null) {
      <div>
        @if (errorObject['required'] ?? false) {
          <kendo-formerror>{{
            'outlook.forms.required-error'
              | translate: { fieldName: translation }
          }}</kendo-formerror>
        }

        @if (errorObject['maxlength'] ?? false) {
          <kendo-formerror>{{
            'outlook.forms.maxlength-error'
              | translate
                : {
                    count:
                      errorObject['maxlength'].requiredLength ??
                      errorObject['maxlength'],
                  }
          }}</kendo-formerror>
        }

        @if (
          !errorObject['maxlength'] &&
          (errorObject['valid'] ||
            errorObject['email'] ||
            (errorObject['pattern'] ?? false))
        ) {
          <kendo-formerror>{{
            'outlook.forms.valid-error' | translate: { fieldName: translation }
          }}</kendo-formerror>
        }

        @if (!errorObject['maxlength'] && (errorObject['exist'] ?? false)) {
          <kendo-formerror>{{
            'outlook.forms.exist-error' | translate: { fieldName: translation }
          }}</kendo-formerror>
        }
      </div>
    }
  `,
  imports: [KENDO_FORM, TranslatePipe],
})
export class OutlookFormErrorComponent implements OnInit {
  constructor(private readonly translate: TranslateService) {}
  @Input() type: 'email' | 'normal' = 'normal';

  @Input() fieldTranslation = '';

  @Input() errorObject: ValidationErrors | null = null;

  translation = '';

  ngOnInit(): void {
    this.translate.get(this.fieldTranslation).subscribe((o) => {
      this.translation = o.toLowerCase();
    });
  }
}
